import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { DateTime } from "luxon";

import { CargoFollowType } from "../../../../cargosAPI";
import { UserType } from "../../../../../users/usersAPI";

const TableHeader = () => {
  const headCells = [
    {
      id: "user",
      align: "left",
      disablePadding: false,
      label: "Usuario",
    },
    {
      id: "date",
      align: "left",
      disablePadding: false,
      label: "Fecha",
    },
    {
      id: "comment",
      align: "left",
      disablePadding: false,
      label: "Comentario",
    },
  ];

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            padding={headCell.disablePadding ? "none" : "normal"}
          >
            {headCell.label}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

export const CargoFollowGrid = ({
  follows,
}: {
  follows: CargoFollowType[];
}) => {
  return (
    <TableContainer
      sx={{
        width: "100%",
        overflowX: "auto",
        position: "relative",
        display: "block",
        maxWidth: "100%",
        "& td, & th": { whiteSpace: "nowrap" },
      }}
    >
      <Table
        aria-labelledby="tableTitle"
        sx={{
          "& .MuiTableCell-root:first-child": {
            pl: 2,
          },
          "& .MuiTableCell-root:last-child": {
            pr: 3,
          },
        }}
      >
        <TableHeader />
        <TableBody>
          {follows.map((row, index) => {
            return (
              <TableRow
                hover
                sx={{
                  "&:last-child td, &:last-child th": { border: 0 },
                }}
                tabIndex={-1}
                key={row.comment + index}
              >
                <TableCell component="th" scope="row" align="left" width={100}>
                  {(row.user as UserType)?.name}
                </TableCell>
                <TableCell align="left" width={130}>
                  {typeof row.date === "string"
                    ? DateTime.fromISO(row.date)?.toLocaleString()
                    : (row.date as DateTime)?.toLocaleString()}
                </TableCell>
                <TableCell
                  align="left"
                  sx={{
                    whiteSpace: "normal !important",
                    wordWrap: "break-word",
                  }}
                >
                  {row.comment}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
